// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as SearchRouteImport } from './routes/search'
import { Route as HistoryRouteImport } from './routes/history'
import { Route as ExportRouteImport } from './routes/export'
import { Route as ComparisonRouteImport } from './routes/comparison'
import { Route as IndexRouteImport } from './routes/index'

const SettingsRoute = SettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => rootRouteImport
          })
const SearchRoute = SearchRouteImport.update({
            id: '/search',path: '/search',getParentRoute: () => rootRouteImport
          })
const HistoryRoute = HistoryRouteImport.update({
            id: '/history',path: '/history',getParentRoute: () => rootRouteImport
          })
const ExportRoute = ExportRouteImport.update({
            id: '/export',path: '/export',getParentRoute: () => rootRouteImport
          })
const ComparisonRoute = ComparisonRouteImport.update({
            id: '/comparison',path: '/comparison',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,ComparisonRoute: ComparisonRoute,ExportRoute: ExportRoute,HistoryRoute: HistoryRoute,SearchRoute: SearchRoute,SettingsRoute: SettingsRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)